import * as z from "zod";
import { UUID_REGEX } from "./authConstants";

// Not `z.uuid()`: zod 4 admits the nil and max UUIDs and versions 6-8, which
// the identity plane's `UUID_REGEX` refuses. One rule on both sides keeps every
// reader ID a Worker accepts an ID the plane accepts.
export const ReaderIdSchema = z.string().regex(UUID_REGEX, "not a reader id");

export type ReaderId = z.infer<typeof ReaderIdSchema>;
